import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import EmptyTableRow from 'src/Component/EmptyTableRow'
import PaginatedTable, { HeadCellI, SortOrderI } from 'src/Component/PaginatedTable'
import DataRow from './DataRow'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

import SearchInput from 'src/Component/SearchInput'
import { useGetTrainerMembershipsQuery } from 'src/api/membershipApi'

const headCells: HeadCellI[] = [
  {
    id: 'purchase_by__first_name',
    sortable: true,
    label: 'Trainer Name',
  },
  {
    id: 'purchase_by__trainer_category__name',
    sortable: true,
    label: 'Trainer Category',
  },
  {
    id: 'plan__plan_name',
    sortable: true,
    label: 'Plan Name',
  },
  {
    id: 'plan__total_price',
    sortable: true,
    label: 'Total Price',
  },
  {
    id: 'transaction_id',
    sortable: true,
    label: 'Transaction ID',
  },
  {
    id: 'purchase_date',
    sortable: true,
    label: 'Purchase Date',
  },
  {
    id: 'expiry_date',
    sortable: true,
    label: 'Expiry Date',
  },
  {
    id: 'status',
    sortable: true,
    label: 'Status',
  },
]

const Trainers = () => {
  // states
  const [page, setPage] = useState<number>(1)
  const [sortOrder, setSortOrder] = useState<SortOrderI>('asc')
  const [sortOrderBy, setSortOrderBy] = useState<string>('') // headCells[i].id

  const [search, setSearch] = useState<string>('')

  // hooks
  const { data: TRAINER_MEMBERSHIPS_RESPONSE, isFetching } = useGetTrainerMembershipsQuery(
    {
      search,
      page,
      pageSize: 10,
      sortBy: (() => {
        if (sortOrder === 'asc') {
          return sortOrderBy
        } else {
          return `-${sortOrderBy}`
        }
      })(),
    },
    { refetchOnMountOrArgChange: true },
  )
  const dispatch = useDispatch<AppDispatch>()

  // functions
  const handlePageChange = (page: number) => {
    setPage(page)
  }

  const handleSorting = (_sortOrderBy: string) => {
    setSortOrder((prevState) => {
      return prevState === 'asc' ? 'desc' : 'asc'
    })
    setSortOrderBy(_sortOrderBy)
  }

  const handleSearch = (value: string) => {
    setPage(1)
    setSearch(value)
  }

  // use effects
  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box className='pageContainer'>
      <Grid container>
        <Grid md={8} sm={12} xs={12}>
          {' '}
        </Grid>
        <Grid md={4} sm={12} xs={12}>
          <Box>
            <SearchInput hasDebounce onChange={handleSearch} />
          </Box>
        </Grid>
      </Grid>

      <Box mt={2}>
        {TRAINER_MEMBERSHIPS_RESPONSE && (
          <PaginatedTable
            title='Trainer Membership'
            headCells={headCells}
            currentPage={page}
            onPageChange={handlePageChange}
            totalPages={Math.ceil(TRAINER_MEMBERSHIPS_RESPONSE?.count / 10)}
            onSortClick={handleSorting}
          >
            <>
              {TRAINER_MEMBERSHIPS_RESPONSE?.results?.length === 0 && (
                <EmptyTableRow cellCount={headCells.length} />
              )}
              {TRAINER_MEMBERSHIPS_RESPONSE?.results?.map((membership) => {
                return (
                  <DataRow
                    key={membership.id}
                    membership={membership}
                  />
                )
              })}
            </>
          </PaginatedTable>
        )}
      </Box>
    </Box>
  )
}

export default Trainers
